import type { GetAllUserTrackingOfGeniallyResponse } from '@genially/contracts';

import type { GeniallyContent } from '../../types/GeniallyContent';

export const processActivitiesDone = (
  trackingData: GetAllUserTrackingOfGeniallyResponse['data'][number],
  geniallyContent: GeniallyContent,
): string => {
  return `${trackingData.answers.length}/${geniallyContent.activities.length}`;
};
